const NUTRIENTS_VALUES = {
  "0-6 months": {
    energy: 530,
    total_fat: 29.4,
    saturated_fat: 4.7,
    total_sfa: 4.7,
    trans_fat: 0.6,
    protein: 8.0,
    added_sugar: 6.6,
    total_free_sugars: 6.6,
    sodium: 500.0,
    fibre: 0,
    potassium: 900.0,
    calcium: 300.0,
    magnesium: 30.0,
    phosphorus: 450.0,
    iron: 0,
    zinc: 0,
    iodine: 100.0,
    thiamine: 0.2,
    riboflavin: 0.4,
    niacin: 2.0,
    vitamin_b6: 0.1,
    folate: 25.0,
    vitamin_b12: 1.2,
    vitamin_c: 20.0,
    vitamin_a: 350.0,
    vit_a: 350.0,
    vitamin_d: 400.0,
  },
  "7-12 months": {
    energy: 680,
    total_fat: 26.4,
    saturated_fat: 6.0,
    total_sfa: 6.0,
    trans_fat: 0.8,
    protein: 10.5,
    added_sugar: 8.5,
    total_free_sugars: 8.5,
    sodium: 650.0,
    fibre: 0,
    potassium: 1100.0,
    calcium: 300.0,
    magnesium: 75.0,
    phosphorus: 450.0,
    iron: 3.0,
    zinc: 2.5,
    iodine: 130.0,
    thiamine: 0.4,
    riboflavin: 0.6,
    niacin: 5.0,
    vitamin_b6: 0.6,
    folate: 85.0,
    vitamin_b12: 1.2,
    vitamin_c: 30.0,
    vitamin_a: 350.0,
    vit_a: 350.0,
    vitamin_d: 400.0,
  },
  "1-3 years": {
    energy: 1110,
    total_fat: 43.2,
    saturated_fat: 9.9,
    total_sfa: 9.9,
    trans_fat: 1.2,
    protein: 12.5,
    added_sugar: 13.9,
    total_free_sugars: 13.9,
    sodium: 1000,
    fibre: 15.0,
    potassium: 1750,
    calcium: 500.0,
    magnesium: 90.0,
    phosphorus: 500.0,
    iron: 8.0,
    zinc: 3.3,
    iodine: 90.0,
    thiamine: 0.7,
    riboflavin: 1.1,
    niacin: 7.0,
    vitamin_b6: 0.9,
    folate: 120.0,
    vitamin_b12: 1.2,
    vitamin_c: 30.0,
    vitamin_a: 390.0,
    vit_a: 390.0,
    vitamin_d: 600.0,
  },
  "4-6 years": {
    energy: 1360,
    total_fat: 37.8,
    saturated_fat: 12.1,
    total_sfa: 12.1,
    trans_fat: 1.5,
    protein: 16.0,
    added_sugar: 17.0,
    total_free_sugars: 17.0,
    sodium: 1300.0,
    fibre: 20.0,
    potassium: 2250.0,
    calcium: 550.0,
    magnesium: 125.0,
    phosphorus: 550.0,
    iron: 11.0,
    zinc: 4.5,
    iodine: 90.0,
    thiamine: 0.9,
    riboflavin: 1.3,
    niacin: 9.0,
    vitamin_b6: 1.2,
    folate: 135.0,
    vitamin_b12: 2.2,
    vitamin_c: 35.0,
    vitamin_a: 510.0,
    vit_a: 510.0,
    vitamin_d: 600.0,
  },
  "7-9 years": {
    energy: 1700,
    total_fat: 47.2,
    saturated_fat: 15.1,
    total_sfa: 15.1,
    trans_fat: 1.9,
    protein: 23.0,
    added_sugar: 21.3,
    total_free_sugars: 21.3,
    sodium: 1600.0,
    fibre: 26.0,
    potassium: 2825.0,
    calcium: 650.0,
    magnesium: 175.0,
    phosphorus: 650.0,
    iron: 15.0,
    zinc: 5.9,
    iodine: 90.0,
    thiamine: 1.1,
    riboflavin: 1.6,
    niacin: 11.0,
    vitamin_b6: 1.5,
    folate: 170.0,
    vitamin_b12: 2.2,
    vitamin_c: 45.0,
    vitamin_a: 630.0,
    vit_a: 630.0,
    vitamin_d: 600.0,
  },
  "10-12 years": {
    energy: 2220,
    total_fat: 61.7,
    saturated_fat: 19.7,
    total_sfa: 19.7,
    trans_fat: 2.5,
    protein: 33.0,
    added_sugar: 27.8,
    total_free_sugars: 27.8,
    sodium: 2000.0,
    fibre: 33.0,
    potassium: 3500.0,
    calcium: 850.0,
    magnesium: 250.0,
    phosphorus: 850.0,
    iron: 28.0,
    zinc: 8.5,
    iodine: 100.0,
    thiamine: 1.5,
    riboflavin: 2.1,
    niacin: 15.0,
    vitamin_b6: 2.0,
    folate: 225.0,
    vitamin_b12: 2.2,
    vitamin_c: 55.0,
    vitamin_a: 790.0,
    vit_a: 790.0,
    vitamin_d: 600.0,
  },
  "13-15 years": {
    energy: 2860,
    total_fat: 79.4,
    saturated_fat: 25.4,
    total_sfa: 25.4,
    trans_fat: 3.2,
    protein: 45.0,
    added_sugar: 35.8,
    total_free_sugars: 35.8,
    sodium: 2000.0,
    fibre: 43.0,
    potassium: 3500.0,
    calcium: 1000.0,
    magnesium: 345.0,
    phosphorus: 1000.0,
    iron: 30.0,
    zinc: 14.3,
    iodine: 140.0,
    thiamine: 1.9,
    riboflavin: 2.7,
    niacin: 19.0,
    vitamin_b6: 2.6,
    folate: 285.0,
    vitamin_b12: 2.2,
    vitamin_c: 70.0,
    vitamin_a: 930.0,
    vit_a: 930.0,
    vitamin_d: 600.0,
  },
  "16-18 years": {
    energy: 3320,
    total_fat: 92.2,
    saturated_fat: 29.5,
    total_sfa: 29.5,
    trans_fat: 3.7,
    protein: 55.0,
    added_sugar: 41.5,
    total_free_sugars: 41.5,
    sodium: 2000.0,
    fibre: 50.0,
    potassium: 3500.0,
    calcium: 1050.0,
    magnesium: 440.0,
    phosphorus: 1050.0,
    iron: 32.0,
    zinc: 17.6,
    iodine: 140.0,
    thiamine: 2.2,
    riboflavin: 3.1,
    niacin: 22.0,
    vitamin_b6: 3.0,
    folate: 340.0,
    vitamin_b12: 2.2,
    vitamin_c: 85.0,
    vitamin_a: 1000.0,
    vit_a: 1000.0,
    vitamin_d: 600.0,
  },
  "Above 18 years": {
    energy: 2000,
    total_fat: 67.0,
    saturated_fat: 22.0,
    total_sfa: 22.0,
    trans_fat: 2.0,
    protein: 54.0,
    added_sugar: 50.0,
    total_free_sugars: 50.0,
    sodium: 2000.0,
    fibre: 30.0,
    potassium: 3500.0,
    calcium: 1000.0,
    magnesium: 440.0,
    phosphorus: 1000.0,
    iron: 29.0,
    zinc: 17.0,
    iodine: 140.0,
    thiamine: 1.4,
    riboflavin: 2.0,
    niacin: 14.0,
    vitamin_b6: 1.9,
    folate: 300.0,
    vitamin_b12: 2.2,
    vitamin_c: 80.0,
    vitamin_a: 1000.0,
    vit_a: 1000.0,
    vitamin_d: 600.0,
  },
}
export default NUTRIENTS_VALUES
